export type DetectionOptionType = 'lice' | 'internal' | 'health' | 'external' | 'laksvel';

export interface DetectionOption {
    value: string;
    label: string;
    type: DetectionOptionType;
    onlyOptoScaleAdmin: boolean;
}

export const dropdownDetectionOptions: DetectionOption[] = [
    {
        value: 'false_lice',
        label: 'organisms.imageViewer.falseDetection.aDetectionIsNotALouse',
        type: 'lice',
        onlyOptoScaleAdmin: false,
    },
    {
        value: 'missed_lice',
        label: 'organisms.imageViewer.falseDetection.aLouseIsNotDetected',
        type: 'lice',
        onlyOptoScaleAdmin: false,
    },
    {
        value: 'false_wound',
        label: 'organisms.imageViewer.falseDetection.aDetectionIsNotAWound',
        type: 'health',
        onlyOptoScaleAdmin: false,
    },
    {
        value: 'multiple_registered',
        label: 'organisms.imageViewer.falseDetection.sameFishRegisteredMultipleTimes',
        type: 'external',
        onlyOptoScaleAdmin: false,
    },
    {
        value: 'wrong_detection',
        label: 'organisms.imageViewer.falseDetection.wrongDetection',
        type: 'laksvel',
        onlyOptoScaleAdmin: false,
    },
    {
        value: 'wrong_score',
        label: 'organisms.imageViewer.falseDetection.wrongScore',
        type: 'laksvel',
        onlyOptoScaleAdmin: false,
    },
    {
        value: 'confused_lice',
        label: 'organisms.imageViewer.falseDetection.aLouseHasWrongType',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'confused_wound',
        label: 'organisms.imageViewer.falseDetection.aWoundHasIncorrectType',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'future_treasure',
        label: 'organisms.imageViewer.falseDetection.interestingForFutureDevelopment',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'gill_shortening',
        label: 'organisms.imageViewer.falseDetection.gillShortening',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_head',
        label: 'organisms.imageViewer.falseDetection.interestingHead',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'deformed_body',
        label: 'organisms.imageViewer.falseDetection.deformedBody',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'fin_damage',
        label: 'organisms.imageViewer.falseDetection.finDamage',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_louse',
        label: 'organisms.imageViewer.falseDetection.interestingLouse',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_wound',
        label: 'organisms.imageViewer.falseDetection.interestingWound',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_scale_loss',
        label: 'organisms.imageViewer.falseDetection.interestingScaleLoss',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'missed_wound',
        label: 'organisms.imageViewer.falseDetection.aWoundIsNotDetected',
        type: 'health',
        onlyOptoScaleAdmin: false,
    },
    {
        value: 'interesting_haemorrhages',
        label: 'organisms.imageViewer.falseDetection.interestingHaemorrhages',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_maturation',
        label: 'organisms.imageViewer.falseDetection.interestingMaturation',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_emaciation',
        label: 'organisms.imageViewer.falseDetection.interestingEmaciation',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_snout_wound',
        label: 'organisms.imageViewer.falseDetection.interestingSnoutWound',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_jaw_deformity',
        label: 'organisms.imageViewer.falseDetection.interestingJawDeformity',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_cataract',
        label: 'organisms.imageViewer.falseDetection.interestingCataract',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
    {
        value: 'interesting_eye_damage',
        label: 'organisms.imageViewer.falseDetection.interestingEyeDamage',
        type: 'internal',
        onlyOptoScaleAdmin: true,
    },
];

export const getLabelByValue = (value: string): string | undefined => {
    return dropdownDetectionOptions.find((detectionOption) => detectionOption.value === value)
        ?.label;
};
